/**
 * Image helper utilities
 */

/**
 * Get full image URL from Strapi media object
 * @param {Object} image - Strapi image object
 * @returns {string} Full image URL
 */
export const getImageUrl = (image) => {
  if (!image) return '';
  
  const baseUrl = process.env.REACT_APP_STRAPI_API_URL || 'http://localhost:1337';
  
  // Handle different Strapi response formats
  if (image.data?.attributes?.url) {
    const url = image.data.attributes.url;
    return url.startsWith('http') ? url : `${baseUrl}${url}`;
  }
  
  if (image.url) {
    return image.url.startsWith('http') ? image.url : `${baseUrl}${image.url}`;
  }
  
  return '';
};

/**
 * Get image alt text from Strapi media object
 * @param {Object} image - Strapi image object
 * @param {string} fallback - Fallback alt text
 * @returns {string} Alt text
 */
export const getImageAlt = (image, fallback = 'Image') => {
  if (!image) return fallback;
  
  if (image.data?.attributes?.alternativeText) {
    return image.data.attributes.alternativeText;
  }
  
  if (image.alternativeText) {
    return image.alternativeText;
  }
  
  if (image.data?.attributes?.name) {
    return image.data.attributes.name;
  }
  
  if (image.name) {
    return image.name;
  }
  
  return fallback;
};

/**
 * Get placeholder image URL
 * @param {number} width - Image width
 * @param {number} height - Image height
 * @returns {string} Placeholder image URL
 */
export const getPlaceholderImage = (width = 800, height = 600) => {
  // Use a simple SVG data URI as placeholder instead of external service
  return `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='${width}' height='${height}' viewBox='0 0 ${width} ${height}'%3E%3Crect fill='%23e2e8f0' width='${width}' height='${height}'/%3E%3Ctext fill='%2394a3b8' font-family='sans-serif' font-size='24' x='50%25' y='50%25' text-anchor='middle' dy='.3em'%3ENo Image%3C/text%3E%3C/svg%3E`;
};

export default {
  getImageUrl,
  getImageAlt,
  getPlaceholderImage,
};
